import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import DestinationCard from "@/components/DestinationCard";
import { toast } from "sonner";

export default function FavoritesPage() {
  const { user, loading } = useAuth();
  const [favs, setFavs] = useState([]);
  useEffect(() => { if (user) api.get("/favorites").then(({ data }) => setFavs(data)); }, [user]);
  if (loading) return null;
  if (!user) return <div className="max-w-md mx-auto px-6 py-24 text-center text-muted-foreground">Please sign in to view favorites.</div>;

  const remove = async (d) => {
    await api.delete(`/favorites/${d.id}`);
    setFavs(favs.filter((x) => x.id !== d.id));
    toast.success("Removed");
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="text-xs uppercase tracking-widest text-accent mb-2">Your favorites</div>
      <h1 className="heading-serif text-5xl mb-10">Saved journeys</h1>
      {favs.length === 0 ? (
        <p className="text-sm text-muted-foreground">You haven't saved any destinations yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
          {favs.map((d) => <DestinationCard key={d.id} d={d} isFav={true} onToggleFav={remove} />)}
        </div>
      )}
    </div>
  );
}
